module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cliente/cliente.component.scss
// module id = ./src/app/cliente/cliente.component.scss
// module chunks = main